import {} from 'react';

const GoalClick = ({ color, size }: { color?: string; size?: number }) => (
  <svg
    width={size || 40}
    height={size || 40}
    viewBox="0 0 80 80"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    color={color}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.7 32.2c-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3h5c.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3h-5zm25 0c-.7 0-1.3.6-1.3 1.3s.6 1.3 1.3 1.3h5c.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3h-5zm-11.3-8.8c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3v-5c0-.7-.6-1.3-1.3-1.3s-1.3.6-1.3 1.3v5zM27.2 43.2c-.5.5-.5 1.3 0 1.8s1.3.5 1.8 0l3.5-3.5c.5-.5.5-1.3 0-1.8s-1.3-.5-1.8 0l-3.5 3.5zm17.6-17.7c-.5.5-.5 1.3 0 1.8s1.3.5 1.8 0l3.5-3.5c.5-.5.5-1.3 0-1.8s-1.3-.5-1.8 0l-3.5 3.5zm-14.1 1.8c.5.5 1.3.5 1.8 0s.5-1.3 0-1.8L29 22c-.5-.5-1.3-.5-1.8 0s-.5 1.3 0 1.8l3.5 3.5zm23.9 38c2.4-3.9 3.8-8.5 3.8-13 0-2-.2-3.9-.7-5.8-.4-1.3-1.4-2.3-2.8-2.3-.8 0-1.6.4-2.1.9v-.2c0-1.6-1.3-2.8-2.8-2.8s-2.8 1.3-2.8 2.8v-1.4c0-1.6-1.3-2.8-2.8-2.8-1.6 0-2.8 1.3-2.8 2.8v-9.1c0-1.6-1.3-2.8-2.8-2.8-1.6 0-2.8 1.3-2.8 2.8v16c0 .8-.6 1.4-1.4 1.4-.1 0-.3 0-.4-.1l-4-1.6c-.4-.2-.8-.3-1.3-.3-1.6 0-2.8 1.3-2.8 2.8 0 1.2.7 2.2 1.7 2.6 4.6 2.4 8.2 5.2 10.8 10.1h16z"
    />
  </svg>
);

export default GoalClick;
